import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { AttachmentPreviewBody, buildAttachmentPreview, revokePreviewUrl } from './attachmentPreviewUtils';

const UpdateAttachment = ({ open, onClose, documentNo, rows, readOnly, onFileSelect, onRemarkChange, onDelete, onView, onSave }) => {
  const [preview, setPreview] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => () => revokePreviewUrl(preview), [preview]);

  const handleClosePreview = () => {
    revokePreviewUrl(preview);
    setPreview(null);
    setPreviewOpen(false);
  };

  const handleViewClick = (row) => {
    const built = buildAttachmentPreview(row);
    if (!built?.url) {
      toast.warning('No file available to view.');
      return;
    }
    onView?.(row);
    revokePreviewUrl(preview);
    setPreview(built);
    setPreviewOpen(true);
  };

  return (
    <>
      <Modal show={open} size="lg" onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Attachments</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex justify-content-between mb-3">
            <label className="pt-2">Document No</label>
            <input disabled value={documentNo} className="form-control w-75" />
          </div>

          <table className="table table-bordered">
            <thead className="dynoTable">
              <tr>
                <th>File Name</th>
                <th>Remarks</th>
                <th>Upload</th>
                <th>View</th>
                <th>Delete</th>
              </tr>
            </thead>

            <tbody>
              {rows
                .filter((row) => !row.isDeleted)
                .map((row) => (
                  <tr key={row.id}>
                    <td>
                      <input disabled value={row.fileName} className="form-control" />
                    </td>

                    <td>
                      <input disabled={readOnly} value={row.remarks} className="form-control" onChange={(e) => onRemarkChange(row.id, e.target.value)} />
                    </td>

                    <td>
                      <input type="file" hidden id={`file-${row.id}`} disabled={readOnly} onChange={(e) => onFileSelect(e.target.files[0], row.id)} />
                      <button className="mainbtn" disabled={readOnly} onClick={() => document.getElementById(`file-${row.id}`).click()}>
                        Upload
                      </button>
                    </td>

                    <td>
                      <button className="mainbtnRed" disabled={!row.fileName} onClick={() => handleViewClick(row)}>
                        View
                      </button>
                    </td>

                    <td>
                      <button className="mainbtnSecondary" disabled={readOnly || !row.fileName} onClick={() => onDelete(row.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <button className="mainbtn" onClick={onClose}>
            Attach
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={previewOpen} size="lg" onHide={handleClosePreview} >
        <Modal.Header closeButton>
          <Modal.Title>{preview?.fileName ? `Preview — ${preview.fileName}` : 'Preview'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AttachmentPreviewBody preview={preview} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateAttachment;
